import { AsyncPipe } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Observable } from 'rxjs';

import { EcmMaterialModule } from '@ecm/material';
import { EcmRouterModule } from '@ecm/router';

import { ButtonViewModel } from '../../../../business/model/home/button.view-model';
import { ForbiddenViewModel } from '../../../../business/model/home/forbidden/forbidden.view-model';
import { ParamsUtils } from '../../../../utils/params.utils';

@Component({
    selector: 'suggested-component',
    templateUrl: 'suggested.component.html',
    standalone: true,
    imports: [EcmMaterialModule, AsyncPipe, EcmRouterModule],
})
export class SuggestedComponent {
    public readonly ParamsUtils = ParamsUtils;

    @Input()
    public viewModel: ForbiddenViewModel;
    @Output()
    public readonly clickPrimaryButtonLink = new EventEmitter<ButtonViewModel>();
    @Output()
    public readonly clickSecondaryButtonLink = new EventEmitter<ButtonViewModel>();

    public isDisabledEclairForbiddenLink: Observable<boolean>;

    public doClickPrimaryButtonLink() {
        this.clickPrimaryButtonLink.emit(this.viewModel.primaryButton);
    }
    public doClickSecondaryButtonLink() {
        this.clickSecondaryButtonLink.emit(this.viewModel.secondaryButton);
    }
}
